var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#FFF",
    x: 0.5,
    y: 2.5,
    width: 31,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 2.5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v4.5H.5V4c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44z",
    stroke: "#595959",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 2,
    y: 5,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 5,
    y: 5,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 8,
    y: 5,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#595959",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.19 14.766.801 2.748.73-2.555c.078-.267.136-.45.173-.547a.712.712 0 0 1 .212-.28c.103-.088.245-.132.426-.132.183 0 .326.044.43.133a.76.76 0 0 1 .218.288c.042.104.1.283.176.538l.73 2.555.81-2.748c.054-.198.098-.342.131-.43a.572.572 0 0 1 .167-.235c.078-.067.19-.101.338-.101a.54.54 0 0 1 .382.153.48.48 0 0 1 .163.36c0 .127-.047.317-.14.573l-1.005 2.946c-.087.249-.154.429-.202.54a.806.806 0 0 1-.228.297c-.103.087-.245.131-.425.131-.187 0-.333-.047-.44-.14a.842.842 0 0 1-.236-.342 6.35 6.35 0 0 1-.167-.527l-.702-2.396-.68 2.396c-.09.333-.188.585-.293.754-.106.17-.29.255-.554.255a.7.7 0 0 1-.345-.079.664.664 0 0 1-.237-.225 1.695 1.695 0 0 1-.166-.347l-.113-.317-.995-2.946c-.1-.277-.149-.467-.149-.572 0-.133.053-.251.158-.356A.527.527 0 0 1 5.545 14c.204 0 .342.058.414.173.073.116.15.313.23.593zM13.69 14.766l.801 2.748.73-2.555c.078-.267.136-.45.173-.547a.712.712 0 0 1 .212-.28c.103-.088.245-.132.426-.132.183 0 .326.044.43.133a.76.76 0 0 1 .218.288c.042.104.1.283.176.538l.73 2.555.81-2.748c.054-.198.098-.342.131-.43a.572.572 0 0 1 .167-.235c.078-.067.19-.101.338-.101a.54.54 0 0 1 .382.153.48.48 0 0 1 .163.36c0 .127-.047.317-.14.573l-1.005 2.946c-.087.249-.154.429-.202.54a.806.806 0 0 1-.228.297c-.103.087-.245.131-.425.131-.187 0-.333-.047-.44-.14a.842.842 0 0 1-.236-.342 6.35 6.35 0 0 1-.167-.527l-.702-2.396-.68 2.396c-.09.333-.188.585-.293.754-.106.17-.29.255-.554.255a.7.7 0 0 1-.345-.079.664.664 0 0 1-.237-.225 1.695 1.695 0 0 1-.166-.347l-.113-.317-.995-2.946c-.1-.277-.149-.467-.149-.572 0-.133.053-.251.158-.356a.527.527 0 0 1 .387-.158c.204 0 .342.058.414.173.073.116.15.313.23.593zM21.19 14.766l.801 2.748.73-2.555c.078-.267.136-.45.173-.547a.712.712 0 0 1 .212-.28c.103-.088.245-.132.426-.132.183 0 .326.044.43.133a.76.76 0 0 1 .218.288c.042.104.1.283.176.538l.73 2.555.81-2.748c.054-.198.098-.342.131-.43a.572.572 0 0 1 .167-.235c.078-.067.19-.101.338-.101a.54.54 0 0 1 .382.153.48.48 0 0 1 .163.36c0 .127-.047.317-.14.573l-1.005 2.946c-.087.249-.154.429-.202.54a.806.806 0 0 1-.228.297c-.103.087-.245.131-.425.131-.187 0-.333-.047-.44-.14a.842.842 0 0 1-.236-.342 6.35 6.35 0 0 1-.167-.527l-.702-2.396-.68 2.396c-.09.333-.188.585-.293.754-.106.17-.29.255-.554.255a.7.7 0 0 1-.345-.079.664.664 0 0 1-.237-.225 1.695 1.695 0 0 1-.166-.347l-.113-.317-.995-2.946c-.1-.277-.149-.467-.149-.572 0-.133.053-.251.158-.356a.527.527 0 0 1 .387-.158c.204 0 .342.058.414.173.073.116.15.313.23.593z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 11,
    y: 21,
    width: 11,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 14,
    y: 24,
    width: 5,
    height: 1,
    rx: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.e783afbf45c2f983838ba05090c55724.svg";
export { ForwardRef as ReactComponent };